export function formatCost (n) {
  if (n === null || n === undefined || !Number.isFinite(n)) return '\u2014'
  if (n === 0) return '$0.00'
  if (n < 0.01) return '<$0.01'
  if (n < 1) return `$${n.toFixed(3)}`
  return `$${n.toFixed(2)}`
}
